export const getLangCode = () => {
  const langarr = navigator.languages;
  const currentUrl = window.location?.pathname;
  const urlParts = currentUrl?.split("/");
  const langCode = !!urlParts[1] ? urlParts[1] : langarr?.[0];
  return langCode;
};
